import React, { useState, useEffect } from 'react';
import {
    defaultRemainingTimeFormatted,
    getRemainingTimeUntilMsTimestamp,
    RemainingTimeFormatted,
} from './countdownHelper';

export interface ICountdownProps {
    countdownTimestampMs: number;
    onCountdown?: () => void;
}

export const Countdown = ({ countdownTimestampMs, onCountdown }: ICountdownProps) => {
    const [remainingTime, setRemainingTime] = useState<RemainingTimeFormatted>(defaultRemainingTimeFormatted);
    const remainingTimeDisplay = `${remainingTime.minutes}:${remainingTime.seconds}`;
    const updateRemainingTime = (countdown: number) => {
        setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            updateRemainingTime(countdownTimestampMs);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [countdownTimestampMs]);

    useEffect(() => {
        if (remainingTime.isCountdownFinish) {
            onCountdown?.();
        }
    }, [remainingTime.isCountdownFinish]);

    return <span>{remainingTimeDisplay}</span>;
};
